module.exports = __webpack_public_path__ + "img/15.c0daf79c.png";